module.exports = __webpack_public_path__ + "assets/img/arrow.0613d6b2.png";